import { useState } from "react";
import type {
  FieldValidationValue,
  ValidationFields,
} from "../ComparativeAnalysisForm.types";

export const useFormValidation = (): {
  baseFieldsValidation: ValidationFields;
  compareFieldsValidation: ValidationFields;
} => {
  const env1 = useState<FieldValidationValue>();
  const env2 = useState<FieldValidationValue>();
  const pipeline1 = useState<FieldValidationValue>();
  const pipeline2 = useState<FieldValidationValue>();
  const pit1 = useState<FieldValidationValue>();
  const pit2 = useState<FieldValidationValue>();
  const task1 = useState<FieldValidationValue>();
  const task2 = useState<FieldValidationValue>();

  const baseFieldsValidation = {
    env: env1,
    pipeline: pipeline1,
    pit: pit1,
    task: task1,
  };

  const compareFieldsValidation = {
    env: env2,
    pipeline: pipeline2,
    pit: pit2,
    task: task2,
  };

  return {
    baseFieldsValidation,
    compareFieldsValidation,
  };
};
